<template>
	<v-container fluid>
		<v-row class="mb-3">
			<v-col cols="7" md="6" class="d-flex align-center">
				<div class="d-flex align-center">
					<v-icon class="me-5" style="color: #ff7e87">mdi-account-circle</v-icon>
					<p class="text-lg-h5 font-weight-600"> {{ $t('verified_agent') }}</p>
				</div>

				<v-btn v-if="!isSmallScreen"
					class="text-capitalize bg-green-accent-1 box-shadow text-black isRounded ml-4 active-btn"
					height="51px">
					<span class="pa-2 ma-2 bg-green rounded-lg">{{ this.activeUsers }}
					</span>
					{{ $t('Active') }}
				</v-btn>
				<v-btn v-if="!isSmallScreen"
					class="text-capitalize bg-red-accent-1 box-shadow text-black isRounded ml-4 active-btn"
					height="51px">
					<span class="pa-2 ma-2 bg-red rounded-lg">{{
						this.inactiveUsers
					}}</span>
					{{ $t('Inactive') }}
				</v-btn>
			</v-col>

			<v-col class="d-flex align-center justify-end">
				<v-text-field variant="plain" density="compact" hide-details v-model="searchQuery"
					@keyup.enter="searchAgent" class="box-shadow isRounded pb-2 pl-2"
					:placeholder="$t('search_by_agent_name')" style="
						border: 1px solid rgba(181, 183, 192, 1);
						background-color: rgba(255, 255, 255, 1);
						border-radius: 16px;
						padding: 8px, 16px, 8px, 16px;
					">
					<template v-slot:prepend>
						<div>
							<v-icon style="color: rgba(0, 0, 0, 1); font-size: 30px" class="ml-2"
								@click="searchAgent">mdi-magnify</v-icon>
						</div>
					</template></v-text-field>
				<v-menu v-model="menu" :close-on-content-click="false" location="bottom">
					<template #activator="{ props }">
						<v-btn v-bind="props" class="text-capitalize isRounded box-shadow mx-4" prepend-icon="mdi-tune"
							append-icon="mdi-chevron-down" height="51px">
							{{ $t('filters') }}({{
								selectedFilterStatus.length +
								selectedFilterRating.length
							}})
						</v-btn>
					</template>
					<v-list width="350" class="mt-3 rounded-xl">
						<v-list-item>
							<div class="d-flex justify-space-between">
								<div class="font-weight-bold">{{ $t('filters') }}</div>
								<v-btn variant="outlined" rounded="xl" size="small" color="grey" @click="clearFilter">{{
									$t('clear_all')
								}}</v-btn>
							</div>
						</v-list-item>
						<v-list-item class="font-weight-bold">{{ $t('by_status') }}</v-list-item>
						<v-list-item class="mx-2 text-body-1" v-for="item in filterStatus">
							<div class="d-flex justify-space-between my-2">
								<div>
									<v-chip variant="text" class="text-black pa-3" :class="item.color"
										density="comfortable">{{
											$t(item.title) }}</v-chip>
								</div>
								<div>
									<label class="checkbox">
										<input v-if="
											selectedFilterStatus.includes(
												item.value
											)
										" type="checkbox" :id="item.value" :value="item.value" @click="getStatusValue(item.value)" checked />
										<input v-else type="checkbox" :id="item.value" :value="item.value"
											@click="getStatusValue(item.value)" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
						</v-list-item>
						<v-divider></v-divider>
						<v-list-item class="font-weight-bold">{{ $t('by_rating') }}</v-list-item>
						<v-list-item class="mx-2 text-body-1" v-for="item in filterRating">
							<div class="d-flex justify-space-between">
								<div class="mt-1">
									{{ item.title }}
									<v-icon class="ml-3" :class="item.color">mdi-star</v-icon>
								</div>

								<div>
									<label class="checkbox">
										<input v-if="
											selectedFilterRating.includes(
												item.value
											)
										" type="checkbox" :id="item.value" :value="item.value" @click="getRatingValue(item.value)" checked />
										<input v-else type="checkbox" :id="item.value" :value="item.value"
											@click="getRatingValue(item.value)" />
										<span class="checkmark"></span>
									</label>
								</div>
							</div>
						</v-list-item>
						<v-list-item>
							<div class="d-flex justify-space-between ma-2">
								<v-btn variant="text" @click="menu = false" class="text-none">{{ $t('close') }}</v-btn>
								<v-btn variant="text" class="bg-red-lighten-2 rounded-xl text-black text-none"
									@click="fetchFilteredIncidentList">{{ $t('confirm') }}</v-btn>
							</div>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>
		<v-card v-if="isFetchingIncidents" height="400px" class="d-flex" align="center">
			<v-card-text class="text-center my-auto">
				<v-progress-circular color="grey" :size="80" indeterminate class="mb-4 mx-auto" />
				<div>Generating Report...</div>
			</v-card-text>
		</v-card>

		<v-card v-else>
			<v-card-text>
				<div class="dashboard">
					<!-- Emit created -->
					<!-- @added = getALlList -->
					<data-table :headers="isSmallScreen ? smallScreenHeaders : headers" :items="items"
						:showDelete="canShowDelete" @openAgentEditor="openEditUserDialog"
						@openDeleteAgent="openDeleteDialog" @openActiveInactiveDialog="openActiveInactiveDialog"
						@totalRowsPerPage="filterRowsPerPage" @pageNumber="changePage">
					</data-table>
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="showDeleteUser" width="auto">
			<v-card rounded="xl">
				<v-card-title>
					<div class="ma-4">
						{{ $t('confirm_delete_agent') }}
						<strong style="color: rgba(255, 126, 135, 1)">"{{ this.agentToDelete }}"</strong>?
					</div>
				</v-card-title>
				<v-card-footer>
					<div class="bg-black">
						<div class="d-flex justify-space-between pa-2">
							<v-btn variant="text" text @click="showDeleteUser = false"
								class="text-none">{{ $t('cancel') }}</v-btn>
							<v-btn variant="text" text @click="confirmDelete(this.agentToDeleteId)">
								<div class="d-flex align-center text-none">
									<div class="mr-2">{{ $t('confirm') }}</div>
									<div>
										<v-icon size="x-large">mdi-arrow-right-thin-circle-outline</v-icon>
									</div>
								</div>
							</v-btn>
						</div>
					</div>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showEditUserProfile" width="auto" persistent>
			<edit-user @closeDialog="showEditUserProfile = false" :agentDetails="agentDetials"
				@emit-update-agent-profile="updateAgentProfile"></edit-user>
		</v-dialog>

		<v-dialog v-model="activeInactiveDialog" width="450">
			<v-card>
				<v-card-title class="text-center font-weight-bold ma-2">Do you want to
					{{ this.agentStatus ? $t('Inactive') : $t('Active'
					) }} this Agent ?
				</v-card-title>
				<v-card-item>
					<div class="d-flex justify-center pa-2">
						<v-avatar :image="agentDetials.pictureUrl" size="100" class="ma-2"></v-avatar>
						<div class="ma-4">
							<div class="font-weight-bold mb-2">
								{{ $t('line_name') }} :
								{{ this.agentDetials.lineName || 'No name' }}
							</div>
							<div class="text-body-1">
								{{
									`${this.agentDetials.firstName} ${this.agentDetials.lastName}`
								}}
							</div>
							<div class="text-body-2">
								{{
									this.agentDetials.specialization ||
									'Computer Technician'
								}}
							</div>
						</div>
					</div>
					<div class="font-weight-bold my-2">{{ $t('reason') }}</div>
					<!--					<v-textarea variant="outlined" v-model="activeInactiveReason">-->
					<!--					</v-textarea>-->
					<v-textarea v-if="agentStatus" variant="outlined" v-model="inactiveReason"></v-textarea>
					<v-textarea v-else variant="outlined" v-model="activeReason"></v-textarea>
				</v-card-item>
				<v-card-footer class="bg-black d-flex justify-space-between pa-2">
					<v-btn elevation="0" class="bg-black font-weight-bold" @click="activeInactiveDialog = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn elevation="0" class="bg-black font-weight-bold" :class="this.agentStatus
						? 'text-red-lighten-2'
						: 'text-green-lighten-2'
						" @click="
							activateDeactivateAgent(
								this.agentDetials.id,
								this.agentStatus
							)
							">{{ $t('confirm') }}
					</v-btn>
				</v-card-footer>
			</v-card>
		</v-dialog>
		<v-dialog v-model="statusChangeDialog" width="500">
			<v-card class="text-center">
				<div class="ma-5 text-lg-h6">
					<span class="text-red-lighten-2 font-weight-bold">{{
						`${this.agentDetials.firstName} ${this.agentDetials.lastName}`
					}}</span>
					has been changed to
					{{ this.agentStatus ? 'Inactive' : 'Active' }}
				</div>
			</v-card>
		</v-dialog>
		<v-snackbar v-model="snackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Profile has been saved .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="snackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
		<v-snackbar v-model="deleteSnackbar" :timeout="5000" rounded="pill" color="#8EEDB3" width="500px">
			<div class="d-flex mx-2">
				<v-icon>mdi-check</v-icon>
				<p class="mx-2">Agent has been deleted .</p>
			</div>
			<template v-slot:actions>
				<div class="mx-2">
					<v-icon color="black" @click="deleteSnackbar = false">
						mdi-close
					</v-icon>
				</div>
			</template>
		</v-snackbar>
	</v-container>
</template>

<script>
import moment from 'moment'
import AgentDataTable from '@/components/AgentDataTable'
import agentService from '@/services/API/agentService'
import searchList from '@/services/API/searchList'
import EditUserProfile from '@/components/EditUserProfile.vue'
import settings from '@/services/API/settings'

export default {
	name: 'HomeView',
	components: {
		'data-table': AgentDataTable,
		'edit-user': EditUserProfile,
	},
	data: () => ({
		agentStatus: Boolean,
		deleteSnackbar: false,
		menu: false,
		agentToDelete: null,
		agentToDeleteId: null,
		selectedFilterStatus: [],
		selectedFilterRating: [],
		itemsDisplay: [],
		statusChangeDialog: false,
		activeInactiveDialog: false,
		showIncidenceResponse: null,
		items: [],
		tags: [],
		file: null,
		snackbar: false,
		isFetchingAgents: false,
		activeInactiveReason: '',
		activeReason: '',
		inactiveReason: '',
		showingId: null,
		activeUsers: '',
		inactiveUsers: '',
		showEditUserProfile: false,
		showDeleteUser: false,
		agentDetials: {},
		environment: import.meta.env.VITE_ENVIRONMENT,
		selectedAgentDetails: {},
		filterRating: [
			{
				title: '1.0',
				value: '1',
				color: 'text-orange-lighten-1',
			},
			{
				title: '2.0',
				value: '2',
				color: 'text-orange-lighten-1',
			},
			{
				title: '3.0',
				value: '3',
				color: 'text-orange-lighten-1',
			},

			{
				title: '4.0',
				value: '4',
				color: 'text-orange-lighten-1',
			},
			{
				title: '5.0',
				value: '5',
				color: 'text-orange-lighten-1',
			},
		],
		filterStatus: [
			{
				title: 'Active',
				value: '1',
				color: 'text-green',
			},
			{
				title: 'Inactive',
				value: '0',
				color: 'text-red',
			},
		],
		headers: [
			{
				text: 'Rating',
				value: 'averageRating',
				sortable: 'true',
			},
			{
				text: 'Agent name',
				value: 'agentDetial',
				width: '25%',
			},

			{
				text: 'Email',
				value: 'email',
				width: '20%',
			},
			{
				text: 'Contact',
				value: 'phone',
				width: '25%',
			},
			{
				text: 'Type',
				value: 'type',
			},
			// {
			// 	text: 'Skills',
			// 	value: 'skills',
			// 	width: '10%',
			// },
			{
				text: 'Status',
				value: 'active',
				sortable: true,
				width: '10%',
			},
			{
				text: '',
				value: 'icon',
				width: '10%',
			},
			{
				text: '',
				value: 'del-icon',
				width: '10%',
			},
		],
		searchQuery: '',
	}),
	created() {
		this.fetchAgentList()
	},
	computed: {
		isSmallScreen() {
			return this.$vuetify.display.smAndDown
		},
		smallScreenHeaders() {
			return this.headers.filter((item) =>
				['Agent name', 'Email', 'Status', ''].includes(item.text)
			)
		},
		canShowDelete() {
			return ['development', 'staging'].includes(this.environment)
		},
	},
	methods: {
		clearFilter() {
			this.selectedFilterStatus.forEach((item) => {
				let box = document.getElementById(item)
				if (box) box.checked = false
			})
			this.selectedFilterRating.forEach((item) => {
				let box = document.getElementById(item)
				if (box) box.checked = false
			})
			this.selectedFilterStatus = []
			this.selectedFilterRating = []
			this.fetchAgentList()
			this.menu = false
		},
		getRatingValue(value) {
			if (!this.selectedFilterRating.includes(value)) {
				this.selectedFilterRating.push(value)
			} else {
				let indexToRemove = this.selectedFilterRating.indexOf(value)
				this.selectedFilterRating.splice(indexToRemove, 1)
			}
		},
		getStatusValue(data) {
			if (!this.selectedFilterStatus.includes(data)) {
				this.selectedFilterStatus.push(data)
			} else {
				let indexToRemove = this.selectedFilterStatus.indexOf(data)
				this.selectedFilterStatus.splice(indexToRemove, 1)
			}
		},
		fetchFilteredIncidentList() {
			if (this.selectedFilterStatus.length > 1) {
				this.fetchAgentList(
					undefined,
					undefined,
					this.selectedFilterRating
				)
			} else {
				this.fetchAgentList(
					undefined,
					this.selectedFilterStatus[0],
					this.selectedFilterRating
				)
			}
			this.menu = false
		},
		async changePage(data) {
			// this.fetchIncidentList(data)
			this.fetchAgentList(data)
		},
		async filterRowsPerPage(data) {
			await settings
				.updatePageSettings(localStorage.getItem('userId'), {
					tableRowsPerPage: data,
				})
				.then((response) => {
					// this.fetchAgentList()
					window.location.reload()
				})
				.catch(() => {
					this.isFetchingIncidents = true
				})
		},
		async getAgentDetials(id) {
			await agentService.getSingleAgent(id).then((response) => {
				this.agentDetials = response.data
			})
		},
		openActiveInactiveDialog(id, status) {
			this.agentStatus = status
			this.getAgentDetials(id)
			this.activeInactiveDialog = true
		},
		async openEditUserDialog(id) {
			await this.getAgentDetials(id)
			this.showEditUserProfile = true
		},
		async openDeleteDialog(data) {
			this.showDeleteUser = true
			this.agentToDelete = data.lineName
			this.agentToDeleteId = data.id
		},
		async confirmDelete(id) {
			await agentService.deleteAgent(id).then(() => {
				this.showDeleteUser = false
				this.deleteSnackbar = true
				this.fetchAgentList()
			})
		},
		async activateDeactivateAgent(id, status) {
			if (status) {
				await agentService
					.deactivateAgent(id, this.inactiveReason)
					.then(() => {
						this.activeInactiveDialog = false
						this.statusChangeDialog = true
						this.fetchAgentList()
					})
			} else {
				await agentService
					.activateAgent(id, this.activeReason)
					.then(() => {
						this.activeInactiveDialog = false
						this.statusChangeDialog = true
						this.fetchAgentList()
					})
			}
		},
		closeDialog() {
			this.$emit('closeDialog')
		},
		async updateAgentProfile(obj) {
			// convert all elements of updateObj.skills to lower case
			obj.skills = obj.skills.map((skill) => skill.toLowerCase())

			// Remove duplicates using Set and convert back to an array
			obj.skills = Array.from(new Set(obj.skills))
			await agentService
				.updateAgentProfile(
					obj.id,
					obj /** send the payload */,
					obj.pictureUrl
				)
				.then(() => {
					this.fetchAgentList()
					this.snackbar = true
				})
				.catch((err) => {
					console.log(err)
				})
		},
		async fetchAgentList(pageNumber, activeStatus, userRatings) {
			this.isFetchingAgents = true
			await agentService
				.getAllAgents(pageNumber, activeStatus, userRatings)
				.then((response) => {
					this.items = response.data.data
					let localActiveUser = 0
					let localInactiveUser = 0
					this.items.forEach((obj) => {
						if (obj.active === true) {
							localActiveUser++
						} else {
							localInactiveUser++
						}
					})
					this.activeUsers = localActiveUser
					this.inactiveUsers = localInactiveUser
				})
				.catch(() => {
					this.isFetchingAgents = true
				})
		},

		async searchAgent() {
			this.isFetchingAgents = true
			if (this.searchQuery) {
				await searchList
					.SearchVerifiedAgent(this.searchQuery)
					.then((response) => {
						this.items = response.data.data
						this.isFetchingAgents = false
					})
					.catch((err) => {
						console.error(err)
						this.isFetchingAgents = false
					})
			} else {
				this.fetchAgentList()
			}
		},
		handleInput() {
			if (!this.searchQuery) {
				this.fetchAgentList()
			}
		},
		async handleAgentDetials(response) {
			this.agentDetials = await response
		},
		countActiveInactivearray(array) {
			let activeCount = 0
			let inactiveCount = 0

			array.forEach((obj) => {
				if (obj.active) {
					this.activeCount = activeCount++
				} else {
					this.inactiveCount = inactiveCount++
				}
			})
		},
	},
}
</script>
<style scoped>
.box-shadow {
	box-shadow: 0px 0px 16px 0px rgba(131, 133, 143, 0.1) !important;
}

.checkbox {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
}

.checkbox input[type='checkbox'] {
	opacity: 0;
	position: absolute;
}

.checkbox .checkmark {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	border: 1px solid #ccc;
	border-radius: 50%;
	transition: background-color 0.2s ease;
}

.checkbox input[type='checkbox']:checked+.checkmark {
	background-color: #0078d4;
	border-color: #0078d4;
}

.checkbox input[type='checkbox']:checked+.checkmark:after {
	content: '';
	display: block;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: #fff;
	transition: transform 0.2s ease;
	transform: scale(1);
}

.checkbox .checkmark:after {
	content: '';
	display: block;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background-color: transparent;
	transform: scale(0);
	transition: transform 0.2s ease;
}
</style>
